import React from "react";
import { Container, Row, Col, Card, CardBody, Badge } from "reactstrap";
import { HelpCircle } from "react-feather";

import Breadcrumbs from "./Breadcrumbs";
import PollResult from "./PollResult";

import questionResult from "../data/resultData";

/**
 * Static result page for a single question, showing the same option
 * list rendered twice as bar charts - once for the "User Poll" and once
 * for the "Panel Poll" - with the correct option highlighted in green.
 */
const QuestionResultPage = () => {
  const { question, options, correctOptionId, userPoll, panelPoll } =
    questionResult;

  return (
    <>

      <Container fluid>
        <Row className="justify-content-center mt-4">
          <Col lg="10">
            <Card className="border-0 shadow-sm mb-4">
              <CardBody>
                <Badge color="primary" pill className="mb-2">
                  Result
                </Badge>

                <h4 className="fw-bold mb-0">
                  <HelpCircle size={20} className="me-2 text-primary" />
                  {question}
                </h4>
              </CardBody>
            </Card>

            <Row>
              <Col md="6" className="mb-4 mb-md-0">
                <PollResult
                  title="User Poll"
                  icon="users"
                  options={options}
                  votes={userPoll.votes}
                  correctOptionId={correctOptionId}
                />
              </Col>

              <Col md="6">
                <PollResult
                  title="Panel Poll"
                  icon="panel"
                  options={options}
                  votes={panelPoll.votes}
                  correctOptionId={correctOptionId}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default QuestionResultPage;
